export default __webpack_public_path__ + "static/finishedwax-523cf91206224576aa0dc104901b0386.webp";